export default __webpack_public_path__ + "static/media/smart-goals.b561aba3.svg";